<template>
  <div v-if="layout === 'grid'" class="photo-wrapper" @click="$emit('open')">
    <img class="photo" :src="photo.url" :alt="photo.title" loading="lazy" />
    <div class="description">
      <span class="title">{{ photo.title }}</span>
    </div>
  </div>
  <div v-else class="card mb-3" @click="$emit('open')">
    <div class="card-img-top">
      <div class="photo-wrapper">
        <img class="photo" :src="photo.url" :alt="photo.title" loading="lazy" />
      </div>
    </div>
    <div class="card-body">
      <div class="card-text">
        <span class="title">{{ photo.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoCard',
  props: {
    photo: { type: Object, required: true },
    layout: { type: String, default: 'grid' },
  },
  emits: ['open'],
}
</script>
